// Every request answers for the branch the user has open, so the header goes
// on all of them except the routes that redirect to S3: the browser carries a
// custom header on to the redirect, and the bucket's CORS rules refuse it.
const REDIRECTS_TO_STORAGE =
  /(^|\/)(project-management\/invoices\/[^/]+\/pdf|plans-estimate\/[^/]+\/(download|plan|preview|sources\/[^/]+)|plans-sow\/[^/]+\/(download|preview))\/?(\?|$)/

export const needsActiveBranchHeader = (url?: string): boolean =>
  Boolean(url && !REDIRECTS_TO_STORAGE.test(url))
